import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

export default function EmailsPanel({ call }) {
  const [emails, setEmails] = useState([]);
  const [active, setActive] = useState(0);
  const loaded = useRef(false);

  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    call("get", "/admin/email-previews").then(setEmails).catch(() => toast.error("Impossibile caricare le email"));
  }, [call]);

  const current = emails[active];
  return (
    <div className="grid lg:grid-cols-12 gap-4" data-testid="emails-panel">
      <div className="lg:col-span-4 space-y-2">
        <p className="text-xs text-[#5A625C] mb-3">
          Anteprima delle email automatiche. Il nome «Giulia» è un esempio: ogni iscritta vede il proprio.
        </p>
        {emails.map((e, i) => (
          <button
            key={e.key}
            onClick={() => setActive(i)}
            data-testid={`email-preview-item-${e.key}`}
            className={`btn-ghost w-full text-left rounded-xl border px-4 py-3 ${
              i === active ? "bg-[#1E231F] text-white border-[#1E231F]" : "bg-white border-[#E5E1D8] hover:border-[#1E231F]"
            }`}
          >
            <span className={`block text-[11px] uppercase tracking-[0.15em] font-bold ${i === active ? "text-white/70" : "text-[#748E63]"}`}>{e.when}</span>
            <span className="block font-semibold text-sm mt-1">{e.subject}</span>
          </button>
        ))}
      </div>
      <div className="lg:col-span-8 bg-white border border-[#E5E1D8] rounded-2xl overflow-hidden">
        {current && (
          <>
            <div className="px-5 py-3 border-b border-[#E5E1D8] text-sm">
              <span className="text-[#5A625C]">Oggetto: </span>
              <span className="font-semibold" data-testid="email-preview-subject">{current.subject}</span>
            </div>
            <iframe title="Anteprima email" srcDoc={current.html} sandbox="" className="w-full h-[640px]" data-testid="email-preview-frame" />
          </>
        )}
      </div>
    </div>
  );
}
